/** Flex fill so nested edit columns pass height to ScrollFade and clip overflow. */
export const metadataFillLayout = {
  flex: 'one',
  minHeight: 'none',
  overflow: 'hidden',
} as const
